import React, { Fragment } from 'react';
import { Form, Input, message, Modal } from 'antd';
import * as CommonService from '../../../../services/CommonService';
import { PRODUCT_TYPE_ENDPOINT } from '../../../../services/endpoint';

const AddProductType = (props) => {

	const { visible, setVisible, callback } = props;

	const [btnLoading, setBtnLoading] = React.useState(false);

	const { getFieldDecorator } = props.form;

	const handleAdd = (e) => {
		e.preventDefault();
		props.form.validateFields(async (err, values) => {
			if (!err) {
				setBtnLoading(true);
				CommonService.create(PRODUCT_TYPE_ENDPOINT, values).then(res => {
					setVisible(false);
					if (res) {
						callback(res);
						props.form.resetFields();
					}
					message.success('Thêm thành công loại sản phẩm');
				}).catch(err => {
					message.error(err?.data?.message || 'Có lỗi xảy ra');
				}).finally(() => setBtnLoading(false));
			}
		});
	};

	return <Fragment>
		<Modal
			title="Thêm loại sản phẩm"
			visible={visible}
			onOk={handleAdd}
			confirmLoading={btnLoading}
			onCancel={() => {
				setVisible(false);
				props.form.resetFields();
			}}
		>
			<Form>
				<Form.Item label="Tên loại sản phẩm" required={true}>
					{getFieldDecorator('name', {
						rules: [
							{
								required: true,
								message: 'Vui lòng nhập tên loại sản phẩm'
							}
						]
					})(<Input autoFocus placeholder={'Tên loại sản phẩm'} />)}
				</Form.Item>
			</Form>
		</Modal>
	</Fragment>;
};

export default Form.create({ name: 'AddProductType' })(AddProductType);
